import { Grid, useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as Shield } from '../../../../assets/summary_shield.svg'
import { KPretty } from '../../../../services/utils'
import { SkyInformationPopover } from '../../../Core/Popover/SkyPopover'
const classNames = require('classnames')

export const LiabilityPlanSummary = ({ options, offerCart }) => {
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const findGuidInOptions = (name) => {
    let value = offerCart[name]
    return options[name].filter((item) => item.value == value)[0]
  }

  const getCoverageTooltip = (coverageName) => {
    let value = options[coverageName]
    return value && value.length > 1 ? value[0].tooltip : undefined
  }

  const getLabelOfValue = (name) => {
    let option = findGuidInOptions(name)
    return option.labels.map((l, i) => {
      return {
        label: l,
        value: option.values[i],
      }
    })
  }

  const getCoverageContents = (coverageName, coverageTitle) => {
    return (
      <>
        <FlexView>
          <div className="text-body gray margin-bottom-small">
            {coverageTitle}
          </div>
          {
            <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
              <div className="text-small">
                {getCoverageTooltip(coverageName)}
              </div>
            </SkyInformationPopover>
          }
        </FlexView>
        {getLabelOfValue(coverageName).map((item) => (
          <FlexView
            key={item.value}
            className="margin-top-basic margin-bottom-basic space-between full-width">
            <li className="text-small backbuttongray">{item.label}</li>
            <div className="text-small gray">{item.value}</div>
          </FlexView>
        ))}
      </>
    )
  }

  const getPolicyCoverageContents = () => {
    return (
      <Grid item xs={12} md={10}>
        <div className="full-width">
          {getCoverageContents('bodily_injury_liability', 'Liability')}

          {offerCart.bodily_injury_underinsured &&
            getCoverageContents(
              'bodily_injury_underinsured',
              'Underinsured Motorist'
            )}

          {offerCart.bodily_injury_uninsured &&
            getCoverageContents(
              'bodily_injury_uninsured',
              'Uninsured Motorist'
            )}

          {offerCart.bodily_injury_uninsured_underinsured &&
            getCoverageContents(
              'bodily_injury_uninsured_underinsured',
              'Uninsured/Underinsured Motorist'
            )}

          <FlexView className="space-between margin-top-small margin-bottom-small">
            <FlexView>
              <div className="text-body gray ">Medical Payments</div>
              {
                <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                  <div className="text-small">
                    {getCoverageTooltip('medical_payments')}
                  </div>
                </SkyInformationPopover>
              }
            </FlexView>
            <div className="text-small gray ">
              {findGuidInOptions('medical_payments').label}
            </div>
          </FlexView>
        </div>
      </Grid>
    )
  }

  return (
    <>
      {isMobile ? (
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs={2}>
            <FlexView hAlignContent={'left'} vAlignContent={'center'}>
              <Shield className="medium-icon" />
            </FlexView>
          </Grid>
          <Grid item xs={10}>
            <div className="text-body blue bold uppercase">
              Policy Coverages
            </div>
          </Grid>
          {getPolicyCoverageContents()}
        </Grid>
      ) : (
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs={12} md={2}>
            <FlexView
              hAlignContent={'center'}
              vAlignContent={'center'}
              style={{ height: '100%' }}>
              <Shield
                className={classNames(
                  { 'big-icon': !isMobile },
                  { 'medium-icon': isMobile }
                )}
              />
            </FlexView>
          </Grid>
          {getPolicyCoverageContents()}
        </Grid>
      )}
    </>
  )
}
